import { router } from "utils/APIUrls"
import axiosConnectorInstance from "./AxiosConnector"
import axios from "axios"
import Swal from "sweetalert2"

export const getUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.get_user,
      requestPayload
    )

    // console.log("Delete event response", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const getCountryAvgData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_country_avg,
      requestPayload
    )

    // console.log("Delete event response", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Manage Category

export const getEvents = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.get_events,
      requestPayload
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

// Virtual User
export const getVirtualUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(router?.get_v_users)

    // console.log(" virtual user  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const addVirtualUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.add_v_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const EditUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.edit_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const deleteUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.delete_user,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const editUserStatus = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.change_user_status,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

// User Notifications User
export const getsearchUsers = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      `${router?.search_users}?keyword=${requestPayload}`
    )

    // console.log(" virtual user  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const sendUserNotification = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.send_notify_to_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

// Leader Board User

export const addLeaderboardUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.leaderboard_add_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const EditLeaderboardUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.leaderboard_edit_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

export const deleteLeaderboardUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.leaderboard_delete_users,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//download user
export const downloadUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.download_user_data,
      { skipToast: true }
    )

    // console.log(" event response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Countries
export const getCountries = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(router?.get_countries)

    // console.log(" virtual user  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Dashboard Leading Data
export const getDashboardLeadingData = async country => {
  try {
    const response = await axiosConnectorInstance.get(
      `${router?.dashboard_leading_data}?countryId=${country}`
    )

    // console.log("dashboard leading  data response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Dashboard User Test Chart Data
export const getDashboardUserTest = async type => {
  try {
    const response = await axiosConnectorInstance.get(
      `${router?.dashboard_user_test}?chartType=${type}`
    )

    console.log("dashboard user and test  data response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Crowd Average Highest Chart Data
export const getCrowdAvgHighData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_crowd_avg_high
    )

    // console.log(" virtual user  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Practice Average Highest Chart Data
export const getPracticeAvgHighData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_practice_avg_high
    )

    // console.log(" virtual user  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Practice Average Highest Chart Data
export const getImgHitData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_by_img_hit
    )

    // console.log("getImgHitData  response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Extra Average Highest Chart Data
export const getExtraAvgHighData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_extra_average_highest
    )

    // console.log("getImgHitData  response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

// edit virtual users in events
export const editVirtualUser = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.edit_nov,
      requestPayload,
      { skipToast: true }
    )

    // console.log(" event response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error.response.data)
    throw error.response.data
  }
}

//Get Practice Average Highest Chart Data
export const getUserTestAvg = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.dashboard_user_test_avg
    )

    // console.log("getImgHitData  response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Get Auto Use Join Data
export const getAutoUserJoinData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.get(
      router?.get_auto_user_join
    )

    // console.log("getImgHitData  response..", response)
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    throw error.response.data
  }
}

//Set Auto Use Join Data
export const setAutoUserJoinData = async requestPayload => {
  try {
    const response = await axiosConnectorInstance.post(
      router?.set_auto_user_join,
      requestPayload
    )

    // console.log("getImgHitData  response..", response);
    return response.data
  } catch (error) {
    console.log("errorerrorerror", error)
    return error.response.data
  }
}
